import useAccess from '@/composables/access/access';
import { computed } from 'vue';
import { experimentFlag } from 'shared/experiments.json';

export default function useAIChat() {
  const { accountHasFeature } = useAccess();

  const canUseAIChat = computed(() => accountHasFeature([experimentFlag.aiChat]));

  return { canUseAIChat };
}
